import React, {memo} from 'react';
import cn from 'classnames';
import styles from './ContainedButton.css';

const sizeTypeStyles = {
	medium: styles.sizeMedium,
	large: styles.sizeLarge,
};

const styleTypeStyles = {
	primary: styles.stylePrimary,
	secondary: styles.styleSecondary,
};

type ButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

interface ContainedButtonProps extends ButtonProps {
	sizeType?: 'medium' | 'large';
	styleType?: 'primary' | 'secondary';
	loading?: boolean;
}

export const ContainedButton = memo<ContainedButtonProps>(props => {
	const {className, styleType = 'primary', sizeType = 'medium', loading, children, ...nativeProps} = props;

	return (
		<button
			className={cn(
				styles.root,
				sizeTypeStyles[sizeType],
				styleTypeStyles[styleType],
				loading && styles.isLoading,
				className,
			)}
			type='button'
			{...nativeProps}>
			{children}
		</button>
	);
});

ContainedButton.displayName = 'ContainedButton';
